{
  "pages": {
    "documents": {
      "title": "Documents Repository",
      "tabs": {
        "documents": "Documents",
        "contracts": "Contracts"
      }
    }
  },
  "components": {
    "documentPreview": {
      "goBack": "Go back to documents repository",
      "loading": "Loading document...",
      "documentNotFound": {
        "title": "Opps! The document does not exist",
        "description": "The requested URL was not found, that's all we know!"
      }
    },
    "documentsTable": {
      "loadError": {
        "title": "Unable to load documents",
        "description": "Please refresh the page or try again later."
      },
      "columns": {
        "name": "Name",
        "type": "Type",
        "contractType": "Contract Type",
        "stage": "Stage",
        "categoryManager": "Category Manager",
        "tags": "Tags",
        "spendCategory": {
          "label": "Spend Category",
          "placeholder": "Select spend category"
        },
        "categorySpend1": "Category Spend 1",
        "categorySpend2": "Category Spend 2",
        "vendor": {
          "label": "Vendor",
          "placeholder": "Select vendor"
        },
        "location": "Location",
        "uploadDate": "Upload Date",
        "more": "More",
        "providedBy": {
          "name": "Provided By",
          "client": "Client",
          "sib": "SIB"
        },
        "anomaly": "Anomaly",
        "cancellationDate": "Cancellation Date / Notice Period",
        "autoRenewalClause": "Auto Renewal Clause",
        "autoRenewalLength": "Auto Renewal Length",
        "notToExceedPercentage": "Not to Exceed %",
        "startDate": "Start Date",
        "endDate": "End Date",
        "matchingDocuments": "Matching Documents",
        "renewalDate": "Renewal Date",
        "annualContractValue": "Annual Contract Value",
        "paymentFrequency": "Payment Frequency",
        "notToExceed": {
          "label": "NTE",
          "tooltip": "Not to exceed"
        },
        "annualPriceIncrease": {
          "label": "API",
          "tooltip": "Annual price increase"
        },
        "sensitive": "Sensitive",
        "earlyTerminationFee": {
          "label": "ETF",
          "tooltip": "Early termination fee"
        },
        "virtual": "Virtual"
      },
      "disabledTooltip": "Editing of {{field}} is disabled as the file is virtual.",
      "actions": {
        "select": {
          "fileUnavailable": "File is temporarily unavailable"
        },
        "updateDocument": {
          "error": "Failed to update document. Please try again.",
          "success": "Document updated successfully"
        },
        "previewVirtualInvoices": "Preview virtual invoices"
      }
    },
    "virtualDocumentsTableModal": {
      "title": "Virtual documents based on <strong>{{name}}</strong>",
      "back": "Back to documents",
      "backToTable": "Back to virtual documents"
    },
    "contractsTable": {
      "columns": {
        "contractId": "Contract ID",
        "negotiationNumber": "Negotiation #",
        "propertyName": "Property Name",
        "vendor": "Vendor",
        "isVetted": "Is Vetted",
        "effectiveDate": "Effective Date",
        "contractStatus": "Contract Status",
        "more": "More"
      }
    },
    "documentsSensitiveFilter": {
      "sensitiveDataOnly": "sensitive data only",
      "tooltip": "Sensitive data is visible to admin users only. Click to display it."
    },
    "documentActions": {
      "copyDocumentName": "Copy document name",
      "deleteDocument": {
        "title": "Are you sure you want to delete <strong>{{name}}</strong> document? This is a destructive action and cannot be undone.",
        "successMessage": "Document has been deleted successfully.",
        "errorMessage": "An error occurred while deleting the document."
      },
      "export": {
        "tooltip": "Download documents",
        "tooltipNoSelection": "No documents selected",
        "errorMessage": "An error occurred while exporting the documents."
      },
      "askAi": {
        "tooltip": "Ask AI",
        "title": "AI Document Assistant",
        "loading": "Loading AI interface...",
        "retry": "Retry"
      },
      "previewDocument": {
        "fileTooBigTooltip": "Document size exceeds the limit of {{size}}MB, please download to view the content.",
        "unsupportedExtensionTooltip": "Unsupported extension, please download to view the content."
      },
      "sensitiveFiles": {
        "markAsSensitive": "Click to mark as sensitive data",
        "removeSensitive": "Click to remove sensitive status",
        "markedAsSensitive": "Marked as sensitive data",
        "markedAsNotSensitive": "Marked as not sensitive data"
      }
    },
    "documentsFilters": {
      "title": "Filters",
      "search": "Search",
      "location": "Location",
      "spendCategory": "Spend category",
      "type": "Type",
      "providedBy": {
        "label": "Provided by",
        "options": {
          "all": "All",
          "sib": "SIB",
          "client": "Client"
        }
      },
      "vendor": "Vendor"
    },
    "tagSelector": {
      "addTag": "Add new tag",
      "addTagPlaceholder": "Tag name",
      "emptyAddTagsPlaceholder": "Add tags",
      "createTag": {
        "errorMessage": "Failed to create tag. Please try again.",
        "successMessage": "Tag has been created successfully."
      },
      "noTags": {
        "title": "No tags found",
        "message": "Enter new tag name to get started."
      },
      "tagExists": {
        "title": "Tag already exists",
        "message": "Please choose a different tag name."
      },
      "tagChars": {
        "title": "Tag cannot exceed 22 characters"
      },
      "checkTag": {
        "errorMessage": "Failed to check tag. Please try again."
      },
      "categories": {
        "predefined": "Predefined Tags"
      }
    },
    "documentViewer": {
      "askAiTitle": "Ask AI",
      "documentViewerTitle": "Document Viewer",
      "errorTitle": "We were unable to load the document",
      "errorDescription": "We were unable to start the AI session needed to view this document. Please refresh the page and try again."
    },
    "noData": {
      "title": "No documents have been uploaded yet",
      "description": "No documents have been uploaded yet, you can add them by either dragging and dropping files here or using the button below.",
      "action": "Upload Files"
    },
    "bulkEditModal": {
      "selectTags": {
        "title": "Add another tags",
        "subtitle": "Previously assigned tags will not be removed. The selected tags will be added to the existing ones. Custom created tags cannot be removed manually."
      },
      "fields": {
        "type": {
          "label": "Type"
        },
        "spendCategory": {
          "label": "Spend category"
        },
        "vendor": {
          "label": "Vendor"
        },
        "renewalDate": {
          "label": "Renewal date"
        },
        "annualContractValue": {
          "label": "ACV - Annual contract value"
        },
        "notToExceed": {
          "label": "NTE - Not to exceed"
        },
        "annualPriceIncrease": {
          "label": "API - Annual price increase"
        },
        "earlyTerminationFee": {
          "label": "ETF - Early termination fee"
        },
        "startDate": {
          "label": "Start date"
        },
        "endDate": {
          "label": "End date"
        },
        "tags": {
          "label": "Tags",
          "placeholder": "Add tags"
        }
      },
      "markAsSensitive": {
        "title": "Mark as sensitive data",
        "description": "Sensitive data will be visible to admin users only"
      },
      "actions": {
        "tooltip": "Bulk edit",
        "tooltipNoSelection": "No documents selected"
      },
      "success_one": "{{count}} document updated successfully",
      "success_other": "{{count}} documents updated successfully",
      "error": "Failed to update documents. Please try again.",
      "undoSuccess": "Changes have been reverted successfully",
      "undoError": "Failed to revert changes. Please try again."
    },
    "quickFilter": {
      "showFor": "Show for",
      "invoices": "Invoices",
      "contracts": "Contracts",
      "showActiveContractsOnly": "show active contracts only",
      "activeContractsTooltip": "Turn off the toggle to display archived contracts",
      "typeFilterDisabledTooltip": "Type filter is controlled by the quick filter above"
    }
  },
  "enums": {
    "documentType": {
      "invoice": "Invoice",
      "contract": "Contract",
      "letterOfAuthorization": "Letter of Authorization",
      "siteList": "Site List",
      "other": "Other"
    },
    "documentStage": {
      "uploaded": "Uploaded",
      "inProgress": "In Progress",
      "actionNeeded": "Action Needed",
      "approved": "Approved",
      "rejected": "Rejected",
      "expired": "Expired"
    },
    "contractType": {
      "msa": "MSA",
      "sow": "SOW",
      "amendment": "Amendment",
      "addendum": "Addendum",
      "orderForm": "Order Form",
      "endUserLicenseAgreement": "End User License Agreement",
      "nda": "NDA",
      "dataSecurityAgreement": "Data Security Agreement",
      "other": "Other"
    },
    "paymentFrequency": {
      "monthly": "Monthly",
      "quarterly": "Quarterly",
      "annually": "Annually",
      "semiAnnual": "Semi-Annual"
    },
    "Category1Spend": {
      "administrativeProductsAndServices": "Administrative Products & Services",
      "automotiveProductsAndServices": "Automotive Products & Services",
      "corporateRealEstate": "Corporate Real Estate (CRES)",
      "equipment": "Equipment",
      "fleet": "Fleet",
      "hrServices": "HR Services",
      "insuranceAndBenefits": "Insurance & Benefits",
      "inventoryRelatedServices": "Inventory Related Services",
      "itProductsAndServices": "IT Products & Services",
      "marketing": "Marketing",
      "mroSupplies": "MRO Supplies",
      "oemPartsInventoryAndService": "OEM Parts, Inventory, & Service",
      "packingAndShippingSupplies": "Packing & Shipping Supplies",
      "professionalServices": "Professional Services",
      "salesAndFinancialOps": "Sales & Financial Ops",
      "telecommunications": "Telecommunications",
      "transportationAndLogistics": "Transportation & Logistics",
      "travel": "Travel",
      "utilities": "Utilities"
    },
    "Category2Spend": {
      "administrativeProducts": "Administrative Products",
      "administrativeServices": "Administrative Services",
      "merchantServicesAndFees": "Merchant Services & Fees",
      "automotivePartsAndAccessories": "Automotive Parts & Accessories",
      "automotiveProducts": "Automotive Products",
      "automotiveServices": "Automotive Services",
      "subletServices": "Sublet Services",
      "construction": "Construction",
      "facilitiesManagementAndMaintenance": "Facilities Management & Maintenance",
      "equipmentAcquisition": "Equipment Acquisition",
      "equipmentMaintenanceAndRepair": "Equipment Maintenance & Repair",
      "equipmentRental": "Equipment Rental",
      "fleet": "Fleet",
      "employeeBenefits": "Employee Benefits",
      "employeeEngagementServices": "Employee Engagement Services",
      "employeeTraining": "Employee Training",
      "hrConsulting": "HR Consulting",
      "payrollProcessing": "Payroll Processing",
      "relocationServices": "Relocation Services",
      "resourcingRecruitment": "Resourcing / Recruitment",
      "corporateInsurance": "Corporate Insurance",
      "employeeInsuranceAndBenefits": "Employee Insurance & Benefits",
      "insuranceAndBenefitsAdministration": "Insurance & Benefits Administration",
      "workersCompensationInsurance": "Worker's Compensation Insurance",
      "auction": "Auction",
      "commercialAutoInsurance": "Commercial Auto Insurance",
      "lendingServices": "Lending Services",
      "manufacturerPayments": "Manufacturer Payments",
      "miscellaneousCreditDebit": "Miscellaneous Credit/Debit",
      "parts": "Parts",
      "rentalServices": "Rental Services",
      "vehicle": "Vehicle",
      "itHardware": "IT Hardware",
      "itServices": "IT Services",
      "itSoftware": "IT Software",
      "customerLoyaltyProgram": "Customer Loyalty Program",
      "digitalMarketing": "Digital Marketing",
      "directMarketing": "Direct Marketing",
      "leadGeneration": "Lead Generation",
      "marketResearch": "Market Research",
      "marketingAndAdvertising": "Marketing & Advertising",
      "marketingEventsAndTradeShows": "Marketing Events & Trade Shows",
      "mediaAndDigitalAdvertisements": "Media & Digital Advertisements",
      "printMediaAndProduction": "Print Media & Production",
      "promotionalProducts": "Promotional Products",
      "sponsorships": "Sponsorships",
      "generalIndustrialSupplies": "General Industrial Supplies",
      "mechanicalProducts": "Mechanical Products",
      "safetySupplies": "Safety Supplies",
      "shopToolsAndSupplies": "Shop Tools & Supplies",
      "uniformsAndUniformLaundry": "Uniforms & Uniform Laundry",
      "weldingSuppliesAndGas": "Welding Supplies & Gas",
      "oemPartsInventoryAndService": "OEM Parts, Inventory, & Service",
      "packaging": "Packaging",
      "pallets": "Pallets",
      "shipping": "Shipping",
      "complianceServices": "Compliance Services",
      "consulting": "Consulting",
      "documentationAndNotaryServices": "Documentation & Notary Services",
      "financialServices": "Financial Services",
      "floorplanFinancing": "Floorplan Financing",
      "legal": "Legal",
      "medicalServices": "Medical Services",
      "publicRelations": "Public Relations",
      "realEstateServices": "Real Estate Services",
      "transcriptionServices": "Transcription Services",
      "treasury": "Treasury",
      "warrantyClaimsAdministrationServices": "Warranty Claims Administration Services",
      "customerReferrals": "Customer Referrals",
      "customerWarrantyAndProtectionPlans": "Customer Warranty & Protection Plans",
      "tagTitleAndRegistrationFees": "Tag, Title & Registration Fees",
      "wholesaleBrokers": "Wholesale Brokers",
      "telecomEquipment": "Telecom Equipment",
      "telecomServices": "Telecom Services",
      "autoTransport": "Auto Transport",
      "freightAndCourier": "Freight & Courier",
      "groundTransportationNonTravel": "Ground Transportation (Non-Travel)",
      "warehouseAndStorage": "Warehouse & Storage",
      "accommodation": "Accommodation",
      "air": "Air",
      "groundTravel": "Ground Travel",
      "mealsAndEntertainment": "Meals & Entertainment",
      "travelOthers": "Travel (Others)",
      "businessMeals": "Business Meals",
      "charitableContributions": "Charitable Contributions",
      "commissionsIncentives": "Commissions / Incentives",
      "customerRebateRefund": "Customer Rebate / Refund",
      "employeeCompensation": "Employee Compensation",
      "employeePayrollAndTaxes": "Employee Payroll & Taxes",
      "expenseReimbursement": "Expense Reimbursement",
      "feesAndCharges": "Fees & Charges",
      "interestDebtPayments": "Interest / Debt Payments",
      "internalTransfer": "Internal Transfer",
      "outOfScopeCostOfSale": "Out of Scope (Cost of Sale)",
      "outOfScopeMiscellaneousGLs": "Out of Scope (Miscellaneous GLs)",
      "pettyCash": "Petty Cash",
      "retirementFundContributions": "Retirement Fund Contributions",
      "revenueAdjustmentsReimbursements": "Revenue Adjustments / Reimbursements",
      "settlementsInsuranceClaims": "Settlements / Insurance Claims",
      "tuitionReimbursement": "Tuition Reimbursement",
      "unionDues": "Union Dues",
      "uncategorized": "Uncategorized",
      "electricity": "Electricity",
      "energyManagementAndPaymentProcessing": "Energy Management & Payment Processing",
      "naturalGas": "Natural Gas",
      "propane": "Propane",
      "waterSewerAndIrrigation": "Water, Sewer & Irrigation"
    }
  }
}
